import type { TopSeller } from '../../types/dashboard'
import { fmt } from '../../lib/dashboardHelpers'

export default function TopSellersPanel({ sellers, channel = 'all', title }: { sellers: TopSeller[], channel?: string; title?: string }) {
    const heading = (title ?? 'Top Sellers') + (channel === 'instore' ? ' - In-Store' : channel === 'online' ? ' - Online' : ' - All Channels')
    return (
        <div className="chart-panel" style={{ height: '100%' }}>
            <div className="chart-panel-title">{heading}</div>
            {sellers.length === 0
                ? <div style={{ textAlign: 'center', padding: '2rem', color: 'var(--color-text-tertiary)' }}>No sales recorded</div>
                : (
                    <div className="chart-panel-content">
                        <table className="top-sellers-table">
                            <thead><tr><th>#</th><th>Product</th><th className="qty">Qty</th><th className="revenue">Revenue</th></tr></thead>
                            <tbody>
                                {sellers.map((s, i) => (
                                    <tr key={i}>
                                        <td style={{ color: 'var(--color-text-tertiary)', width: 30 }}>{i + 1}</td>
                                        <td>
                                            <div>{s.description}</div>
                                            {s.brand && <div className="brand">{s.brand} · {s.prodNo}</div>}
                                        </td>
                                        <td className="qty">{s.qty}</td>
                                        <td className="revenue">{fmt(s.revenue, 'currency')}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
        </div>
    )
}
